import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ModalService } from '../../core/services/modal.service';
import { UserService } from '../../core/services/data/user.service';

@Component({
	selector: 'app-author-profile-cta',
	templateUrl: './author-profile-cta.component.html',
	styleUrls: ['./author-profile-cta.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})

export class AuthorProfileCtaComponent implements OnInit, OnDestroy {
	authorLink: string;

	private subscriptions$ = new Subscription();

	constructor(
		private userService: UserService,
		private modalService: ModalService,
		private router: Router,
	) {}

	ngOnInit(): void {
		this.subscriptions$.add(this.userService.author$.subscribe((author: any) => {
			this.authorLink = author.authorLink;
		}));
	}

	ngOnDestroy() {
		this.subscriptions$.unsubscribe();
	}

	cancel() {
		this.modalService.close('author-profile-cta');
		this.userService.wasShownAuthorProfileCTA().subscribe();
	}

	goToAuthorProfile() {
		this.router.navigate(['/author-dashboard', this.authorLink, 'author-profile']);
		this.cancel();
	}
}
